import { gql } from "@apollo/client";
import { AccountFragment } from "fragments/account";

// One fragment, not two. A pack row is five short strings — there is no
// unbounded field on it — so the split sections need, a listing fragment that
// leaves the body behind, would buy nothing here. Same argument as
// site-domain's.
export const SitePackFragment = gql`
  fragment SitePackFragment on SitePack {
    id
    packId
    route
    type
    fileId
    status
    createdAt
    updatedAt
  }
`;

// Through the site, like everything else in this app. A pack mounts a prefix
// on ONE site's routes and points at one of that site's own documents, so the
// path is the tenancy boundary rather than a stylistic nesting.
export const list = gql`
  query SitePackList($siteId: String!, $input: ListInput) {
    viewer {
      id
      account {
        ...AccountFragment
        sites {
          id
          get(siteId: $siteId) {
            id
            packs {
              id
              list(input: $input) {
                id
                last
                items {
                  ...SitePackFragment
                }
              }
            }
          }
        }
      }
    }
  }
  ${AccountFragment}
  ${SitePackFragment}
`;

export const get = gql`
  query SitePackGet($siteId: String!, $packId: String!) {
    viewer {
      id
      account {
        ...AccountFragment
        sites {
          id
          get(siteId: $siteId) {
            id
            packs {
              id
              get(packId: $packId) {
                ...SitePackFragment
              }
            }
          }
        }
      }
    }
  }
  ${AccountFragment}
  ${SitePackFragment}
`;

export const create = gql`
  mutation SitePackNew($siteId: String!, $input: SitePackInputCreate!) {
    viewer {
      account {
        sites {
          get(siteId: $siteId) {
            packs {
              create(input: $input) {
                ...SitePackFragment
              }
            }
          }
        }
      }
    }
  }
  ${SitePackFragment}
`;

export const edit = gql`
  mutation SitePackUpdate($siteId: String!, $packId: String!, $input: SitePackInputUpdate!) {
    viewer {
      account {
        sites {
          get(siteId: $siteId) {
            packs {
              get(packId: $packId) {
                update(input: $input) {
                  ...SitePackFragment
                }
              }
            }
          }
        }
      }
    }
  }
  ${SitePackFragment}
`;

export const remove = gql`
  mutation SitePackRemove($siteId: String!, $packId: String!) {
    viewer {
      account {
        sites {
          get(siteId: $siteId) {
            packs {
              get(packId: $packId) {
                remove
              }
            }
          }
        }
      }
    }
  }
`;

// Every mutation here changes what the list shows — a create adds a row, an
// update moves a route or attaches an archive (which is what flips `status`
// from pending to active), a remove takes it away — so all three evict the
// same keys.
//
// The literal has to match what `SitePackQueries.id` resolves to on the API
// side (`${site.id}/packs/queries`). If the two drift the mutation still
// succeeds and the list keeps showing the old state, which is exactly the
// silent staleness the page and section specs exist to catch.
export const update = () => (cache) => {
  Object.keys(cache.data.data).forEach((key) => {
    if (key.includes(`packs/queries`)) {
      cache.data.delete(key);
    }
  });
};
